import {isDeviceiOS, isMac} from '../utils/iOS';

/**
 * Finds friendly captcha widget.
 *
 * @param {string} selector - selector for container of the widget.
 * @returns {object|null} widget instance
 */
const getWidget = selector => {
    let widget = null;

    const fcContainer = document.querySelector(selector);

    if (fcContainer && typeof window.friendlyChallenge !== 'undefined') {
        widget = new window.friendlyChallenge.WidgetInstance(fcContainer);
    }

    return widget;
};

/**
 * Finds friendly captcha widget.
 *
 * @param {string} selector - selector for container of the widget.
 */
export const init = selector => {
    const widget = getWidget(selector);

    if (widget) {
        widget.init();
    }
};

/**
 * Resets friendly captcha widget.
 *
 * @param {string} selector - selector for container of the widget.
 * @param {boolean} [restart=false] - whether to restart the captcha (if it's not been already started).
 */
export const reset = (selector, restart = false) => {
    const widget = getWidget(selector);

    if (widget) {
        widget.reset();
        if (restart && !widget.hasBeenStarted) {
            widget.start();
        }
    }
};

/**
 *  Starts the Friendly Captcha Widget.
 *
 * @param {string} selector - selector for container of the widget.
 */
export const start = selector => {
    const widget = getWidget(selector);

    if (!widget.hasBeenStarted) {
        widget.start();
    }
};

/**
 * Attaches on touch event to element.
 *
 * @param {string} selector - selector of container of the widget.
 * @param {jQuery} elementToAttach - element that will have the new event.
 */
export const attachOnTouched = (selector, elementToAttach) => {
    const fcContainer = document.querySelector(selector);

    if (fcContainer && (isDeviceiOS() || isMac())) {
        window.addEventListener('load', () => {
            if (typeof friendlyChallenge !== 'undefined') {
                const widget = new friendlyChallenge.WidgetInstance(fcContainer);
                elementToAttach.one('click', () => {
                    if (!widget.hasBeenStarted) {
                        widget.start();
                    }
                });
            }
        });
    }
};

/**
 * Disables form submission buttons for when the captcha needs a restart.
 *
 * @param {HTMLFormElement} form - current form element.
 */
export const disableSubmitButtons = form => {
    if (form) {
        const buttons = form.querySelectorAll('.frc-captcha-btn');
        buttons.forEach(button => (button.disabled = true));
    }
};
